:host {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-2);
}
#items {
  overflow: hidden;
  flex: 1 1 1000000px; /* By setting the flex-basis to a massive number, we ensure that the #items section will be as tall as possible, and never shrink when the number of elements within #items changes. This prevents a recalculation of the number of pages needed to display all the contents. */
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  /* 
    NOTE: **Be careful when specifying a flex-box "gap" for items.**   
    Browsers seem to treat gap as a "best effort", and you can end up with extremely subtle off-by-0.00001px rounding errors.
  */
}
#items ::slotted(*) {
  /* 
    NOTE: **Be careful when specifying a "margin" for slotted items.**
    Browsers seem to treat margin as a "best effort", and you can end up with extremely subtle off-by-0.00001px rounding errors.
  */
}

#paginator-wrapper {
  display: flex;
}
#paginator {
  flex-shrink: 0;
  display: inline-flex;
  align-items: stretch;
  gap: var(--spacer-05);
  margin-left: auto;
  margin-right: auto;
}
#paginator > :is(button:hover, button:focus) {
  background: var(--theme-menu-active-background);
}

#pageNumber {
  position: relative;
  background: var(--theme-primary-background);
  white-space: nowrap;
  text-align: center;
}
#pageNumber input {
  border-radius: var(--Common--border-radius);
}
input {
  text-align: inherit;
  width: auto;
  min-width: none;
  max-width: 100%;
  padding: 0;
  margin: 0;
  font: inherit;
  border: none;
  box-sizing: border-box;
  font: inherit;
  position: absolute;
  inset: 0;
  background: transparent;
  opacity: 0;
  box-shadow: 0 0 0 2px transparent;
  border-radius: var(--Common--border-radius);
}
input:focus-visible,
button:focus {
  box-shadow: var(--box-shadow-focus-ring);
  outline: none;
}
:is(#pageNumber:hover, #pageNumber:focus-within) input {
  opacity: 1;
  box-shadow: 0 0 0 1px var(--theme-primary-border);
}
#pageNumber:focus-within input {
  box-shadow: var(--box-shadow-focus-ring);
}

input:is(:focus-visible, :hover) + span {
  visibility: hidden;
}

button {
  padding: 0 var(--spacer-1);
  background: none;
  border: none;
  font-size: smaller;
  border-radius: var(--Common--border-radius);
}
button:not([disabled]) {
  color: var(--theme-link-text);
  cursor: pointer;
}
aha-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
[aria-hidden='true'],
::slotted(*[aria-hidden='true']) {
  display: none !important;
}
[disabled] {
  cursor: not-allowed;
  filter: saturate(30%);
}

:host([align='left']) #paginator {
  margin-left: 0;
}
:host([align='right']) #paginator {
  margin-right: 0;
}

/* FLAVOR: "block" */
:host([flavor='block']) #paginator {
  gap: 0;
}
:host([flavor='block']) #paginator > * {
  border: 1px solid var(--theme-primary-border);
  border-radius: 0;
}
:host([flavor='block']) #paginator > button {
  min-width: 2em;
}
:host([flavor='block']) #paginator > *:first-child {
  border-top-left-radius: var(--Common--border-radius);
  border-bottom-left-radius: var(--Common--border-radius);
}
:host([flavor='block']) #paginator > *:last-child {
  border-top-right-radius: var(--Common--border-radius);
  border-bottom-right-radius: var(--Common--border-radius);
}
:host([flavor='block']) #paginator > *:not(:first-child) {
  margin-left: -1px;
}
:host([flavor='block']) #pageNumber input {
  border-radius: 0;
}
:host([flavor='block']) #paginator > :is(button:hover, button:focus),
:host([flavor='block']) :is(#pageNumber:hover, #pageNumber:focus-within) input {
  background: var(--theme-tertiary-background);
}
:host([flavor='block']) :is(:focus-within, :focus) {
  z-index: 1;
}
